"use client";
import { Button, ButtonStyle, Card, CardTitle, DateRangePicker, FormGroup, Grid, GridItem, TextInput } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import React from 'react';
import { HistoryFilterType } from './types';
import { MetricLocalizationsFilter, NumericFromToFilter, VehicleCategoriesFilter, VehiclesWarningsFilter } from '@/components';
import { emptyHistoryFilter } from './constants';

type Props = {
  filters: HistoryFilterType,
  isLoading?: boolean,
  setFilters: (filters: HistoryFilterType) => void,
  onSubmit: () => void
}

const VehicleListFilterContainer = ({filters, setFilters, onSubmit, isLoading}: Props) => {
  const { translate } = useTranslations();

  return (
    <Card>
      <Card.Body>
        <CardTitle title={translate('Filtrowanie wyników')}/>
        <Grid columns={1} mdColumns={12} gap={5}>
          <GridItem mdColSpan={6} lgColSpan={4} xlColSpan={3}>
            <MetricLocalizationsFilter
              value={filters.vehicleRecordsRequest.metricPointsUIds}
              handleChange={(e) => setFilters({
                ...filters, 
                vehicleRecordsRequest: { 
                  ...filters.vehicleRecordsRequest, 
                  metricPointsUIds: e.target.value 
                }
              })} 
            />
          </GridItem>
          <GridItem mdColSpan={6} lgColSpan={4} xlColSpan={3}>  
            <VehiclesWarningsFilter
              value={filters.vehiclesWarnings}
              handleChange={(value) => setFilters({
                ...filters, 
                vehiclesWarnings: value
              })} 
            /> 
          </GridItem>
          <GridItem mdColSpan={6} lgColSpan={4} xlColSpan={6}>  
            <VehicleCategoriesFilter
              value={filters.categories}
              handleChange={(e) => setFilters({
                ...filters, 
                categories: e.target.value
              })} 
            />
          </GridItem>
          <GridItem mdColSpan={6} xlColSpan={3}>  
            <FormGroup label={translate('Liczba osi')}>
              <NumericFromToFilter
                value={filters.axelsCounts}
                handleChange={(value) => setFilters({
                  ...filters, 
                  axelsCounts: value
                })} 
              />
            </FormGroup>
          </GridItem>
          <GridItem mdColSpan={6} xlColSpan={3}>  
            <FormGroup label={translate('Przekroczona DCM')}>
              <NumericFromToFilter
                value={filters.overweightLimit}
                handleChange={(value) => setFilters({
                  ...filters, 
                  overweightLimit: value
                })} 
              />
            </FormGroup>
          </GridItem>
          <GridItem mdColSpan={6} xlColSpan={3}>  
            <FormGroup label={translate('Przekroczenie nacisków osi')}>
              <NumericFromToFilter
                value={filters.axleOverweight}
                handleChange={(value) => setFilters({
                  ...filters, 
                  axleOverweight: value
                })} 
              />
            </FormGroup>
          </GridItem>
          <GridItem mdColSpan={6} xlColSpan={3}>  
            <FormGroup label={translate('Przedział czasowy')}>
              <DateRangePicker
                value={filters.dates}
                handleChange={(event: any, dates: any) => setFilters({
                  ...filters, 
                  dates: dates
                })} 
              />
            </FormGroup>
          </GridItem>
          <GridItem mdColSpan={6} xlColSpan={3}>  
            <FormGroup 
              label={translate('Tablica rejestracyjna (Dzienna historia przejazdu)')} 
              // tooltip={{message: "Wyniki będą filtrowane według tej tablicy tylko jeśli jest to auto powyżej 3,5 tony, w okresie ostatnich 24 godzin."}}
            >
              <TextInput
                value={filters.above35LastDayPlateNumber}
                handleChange={(_e, value?: string) => setFilters({
                  ...filters, 
                  above35LastDayPlateNumber: value
                })} 
              />
            </FormGroup>
          </GridItem>
        </Grid>
      </Card.Body>
      <Card.Footer>
        <Button
          handleClick={() => setFilters({...emptyHistoryFilter})}
          style={ButtonStyle.Outlined}
          disabled={isLoading}
        >
            {translate('Wyczyść')}
        </Button>
        <Button
          handleClick={onSubmit}
          disabled={isLoading}
        >
            {translate('Filter')}
        </Button>
      </Card.Footer>
  </Card>
  );
};

export default VehicleListFilterContainer;